import {SubsidiaryDao} from '../../dao';
import {SubsidiaryModel} from '../../models';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'UPDATE_SUBSIDIARY_BY_ID';

export async function updateSubsidiaryById(
    userData: Record<string, string>,
    subsidiaryId: number,
    update: Record<string, any>
) {
    try {
        const result = await SubsidiaryDao.updateSubsidiaryById(userData.userToken, subsidiaryId, update);

        const resultParsed = SubsidiaryModel.parseSubsidiary(result);

        return resultParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
